<template>
	<div>
		<h5>Informations</h5>
		<CRow>
			<CCol col="6">
				<CInput name="name" label="Désignation" :value="item.name" />
			</CCol>
		</CRow>

		<CRow>
			<CCol col="12">
				<CInput name="address" label="Adresse" :value="item.address" />
			</CCol>
			<CCol col="6">
				<CInput name="city" label="Ville" :value="item.city" />
			</CCol>
			<CCol col="6">
				<CInput name="postalCode" label="Code postal" :value="item.postalCode" />
			</CCol>
			<CCol col="12" class="mb-3">
				<GInputPhoneNumber input-name="phone" :value="item.phone" />
			</CCol>

			<CCol col="6">
				<CInput name="latitude" label="GPS (Latitude)" :value="item.latitude" />
			</CCol>
			<CCol col="6">
				<CInput name="longitude" label="GPS (Longitude)" :value="item.longitude" />
			</CCol>

			<CCol col="12">
				<hr />
			</CCol>
		</CRow>

		<h5>Horaires d'ouverture</h5>
		<CRow v-for="item in openDates" :key="item.index">
			<CCol col="3">
				<GTreeView
					label="Jour de la semaine"
					:local-data="daysOfWeekOptions"
					:multiple="false"
					v-on:update:selected="data => (item.dayOfWeek = data)"
					:input-name="`openDates[${item.index}].dayOfWeek`"
					:value="item.dayOfWeek ? item.dayOfWeek : null" />
			</CCol>

			<CCol col="3">
				<CInput
					label="Heure d'ouverture"
					v-model="item.openHour"
					:name="`openDates[${item.index}].openHour`" />
			</CCol>

			<CCol col="3">
				<CInput
					label="Heure de fermeture"
					v-model="item.closeHour"
					:name="`openDates[${item.index}].closeHour`" />
			</CCol>

			<CCol col="3">
				<div style="margin-bottom: 30px"></div>

				<CButton color="primary mr-2" @click="append">+</CButton>
				<CButton color="primary" @click="remove(item.index)">-</CButton>
			</CCol>
		</CRow>

		<CRow>
			<CCol col="12">
				<hr />
			</CCol>

			<CCol col="6">
				<GInputCheckbox
					name="enabled"
					label="Etat (activer/désactiver)"
					:checked="isEnabled"
					:value="true" />
			</CCol>
		</CRow>
	</div>
</template>

<script>
	import GTreeView from '@/components/ghostlexly-components/GTreeView';
	import { last, remove } from 'lodash';
	import GInputPhoneNumber from '@/components/ghostlexly-components/GInputs/GInputPhoneNumber';
	import GInputCheckbox from '@/components/ghostlexly-components/GInputs/GInputCheckbox';
	export default {
		name: 'pickup-points-form',
		components: { GInputCheckbox, GInputPhoneNumber, GTreeView },

		props: {
			item: {
				type: Object,
				default: () => {
					return {};
				},
			},
		},

		watch: {
			item() {
				if (this.item.openDates) {
					let index = 0;
					this.openDates = this.item.openDates.map(o => {
						index++;
						return { ...o, index: index };
					});
				}
			},
		},

		data() {
			return {
				openDates: [{ index: 0 }],

				daysOfWeekOptions: [
					{ '@id': 1, name: 'lundi' },
					{ '@id': 2, name: 'mardi' },
					{ '@id': 3, name: 'mercredi' },
					{ '@id': 4, name: 'jeudi' },
					{ '@id': 5, name: 'vendredi' },
					{ '@id': 6, name: 'samedi' },
					{ '@id': 7, name: 'dimanche' },
				],
			};
		},

		computed: {
			isEnabled() {
				return this.item.enabled;
			},
		},

		methods: {
			append() {
				this.openDates.push({ index: last(this.openDates).index + 1 });
			},

			remove(index) {
				this.openDates = remove(this.openDates, n => {
					return n.index !== index;
				});
			},
		},
	};
</script>
